const paragraphsLists = [
  {
    name: 'Paragraph Large',
    description: 'Tondo Light / Font Size: 20px / Line-Height: 25px / Spacing: 0.2',
    className: 'p.large',
    type: 'paragraphsLists',
    rows: 5,
  },
  {
    name: 'Paragraph Body',
    description: 'Tondo Light / Font Size: 16px / Line-Height: 24px / Spacing: 0.1',
    className: 'p',
    type: 'paragraphsLists',
    rows: 4,
  },
  {
    name: 'Paragraph Small',
    description: 'Tondo Light / Font Size: 12px / Line-Height: 19px / Spacing: 0.4',
    className: 'p.small',
    type: 'paragraphsLists',
    rows: 3,
  },
  {
    name: 'List',
    description: 'Tondo Light / Font Size: 12px / Line-Height: 30px / Spacing: 0.5',
    className: '.list',
    type: 'paragraphsLists',
    rows: 3,
    items: [
      'Lorem ipsum dolor sit amet',
      'Lorem ipsum dolor sit amet',
      'Lorem ipsum dolor sit amet'
    ]
  },
];

export default paragraphsLists;



// WEBPACK FOOTER //
// ./src/containers/foundations/TextStyles/constants/paragraphsLists.js